import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AboutUs from '../pages/AboutUs/AboutUs';
import NotFound from '../pages/NotFound/NotFound';
import Partnerships from '../pages/Partnerships/Partnerships';
import ProjectDetails from '../pages/ProjectDetails/ProjectDetails';
import './App.scss';
import Contact from './common/Contact/Contact';
import Header from './common/Header/Header';
import PreContact from './common/PreContact/PreContact';
import Projects from './common/Projects/Projects';
import Slider from './common/Slider/Slider';
import Footer from './ui/Footer/Footer';
import Navbar from './ui/Navbar/Navbar';

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <Header />
              <Slider />
              <Projects />
              <PreContact />
              <Contact />
            </>
          } />
          <Route path="/projeto/:id" element={<ProjectDetails />} />
          <Route path="/parcerias" element={<Partnerships />} />
          <Route path="/sobre-nos" element={<AboutUs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;